export default {
  inject: ['load'],
  data() {
    return {};
  },
  methods: {
    getPatientVitalSignByIdFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientVitalSignById', id).then(() => {
        if (this.$store.state.patientVitalSignModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientVitalSignModule.patientVitalSign;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientVitalSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientVitalSignModule.successFlag) {
                this.getPatientVitalSignByIdFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPatientVitalSignFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientVitalSign', id).then(() => {
        if (this.$store.state.patientVitalSignModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientVitalSignModule.allPatientVitalSign;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientVitalSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientVitalSignModule.successFlag) {
                this.getAllPatientVitalSignFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientVitalSignFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientVitalSign', data).then(() => {
        if (this.$store.state.patientVitalSignModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.patientVitalSignAdded();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientVitalSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientVitalSignModule.successFlag) {
                this.addPatientVitalSignFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePatientVitalSignFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deletePatientVitalSign', id).then(() => {
        if (this.$store.state.patientVitalSignModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllPatientVitalSignFunction(this.patientId);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientVitalSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePatientVitalSignFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientVitalSignModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
